/**
 * PreferencesCtrl controller
 * Edit account's preferences
 */

import { PREFERENCES_DEFAULTS, PROVIDERS_CONST } from 'app/core/constants'

/**
 * PreferencesCtrl controller
 *
 * @class PreferencesCtrl
 * @memberof mwApp/preferences
 * @see mwApp/preferences
 *
 * @ngdoc controller
 * @name mwApp/preferences.controller:PreferencesCtrl
 */
/* @ngInject */
export default function PreferencesCtrl ($rootScope, $scope, storageSvc) {
  var vm = this

  /**
   * Storage to save skins
   *
   * @private
   * @memberof mwApp/preferences.controller:PreferencesCtrl~
   * @type {mwApp/common.service:storageSvc}
   */
  const storage = storageSvc.local // use localStorage

  vm.providersConst = PROVIDERS_CONST
  vm.PROVIDER = window.ENV.APP_PROVIDER

  /**
   * Skin
   *
   * @private
   * @memberof mwApp/preferences.controller:PreferencesCtrl~
   * @type {mwApp/common.service:storageSvc}
   */
  let skin = storage.get('skin', PREFERENCES_DEFAULTS.skin)

  vm.colorScheme = storage.get('colorScheme')

  /**
   * Color scheme handler
   * @memberof mwApp/preferences.controller:PreferencesCtrl
   * @param {String} colorScheme - scheme name
   */
  vm.changeScheme = function (colorScheme) {
    vm.colorScheme = colorScheme

    const bodyTag = angular.element(document.querySelector('body'))

    storage.set('colorScheme', colorScheme)
    const darkColorSchemeSelector = window.matchMedia('(prefers-color-scheme: dark)')

    if (colorScheme === 'system' && darkColorSchemeSelector.matches) {
      colorScheme = 'dark'
    }

    if (colorScheme === 'dark') {
      bodyTag.addClass('dark-scheme')
    } else {
      bodyTag.removeClass('dark-scheme')
    }
  }

  /**
   * Check sidebar skin
   *
   * @memberof mwApp/preferences.controller:PreferencesCtrl
   * @param {String} name - skin name (css styles)
   */
  vm.isSidebarSkin = (name) =>
    skin.sidebar === name ? 'selected' : ''

  /**
   * Event occurs when used changes skin <br>
   * Fires in {@link mwApp/preferences.controller:PreferencesCtrl} controller
   *
   * @event event:changeSkin
   * @memberof mwApp
   */

  /**
   * Set sidebar skin
   *
   * @memberof mwApp/preferences.controller:PreferencesCtrl
   * @param {String} name - skin name (css styles)
   */
  vm.setSidebarSkin = (name) => {
    skin.sidebar = name
    $rootScope.$emit('event:changeSkin', skin)
    storage.set('skin', skin)
  }

  /**
   * Change 'skin' event listener
   */
  const storageListener = (e) => {
    if (e.key === 'skin' && e.newValue) {
      skin = storage.get('skin', PREFERENCES_DEFAULTS.skin)
    }
  }

  // add 'skin' change event listener
  window.addEventListener('storage', storageListener)

  // on controller destroy -> remove 'skin' change event listener
  $scope.$on('$destroy', () => window.removeEventListener('storage', storageListener))

  //
}
